import { render, staticRenderFns } from "./template.vue?vue&type=template&id=47fefb72&scoped=true&"
import script from "@/Components/Global/InitialsButton/component.ts?vue&type=script&lang=ts&"
export * from "@/Components/Global/InitialsButton/component.ts?vue&type=script&lang=ts&"
import style0 from "@/Components/Global/InitialsButton/style.scss?vue&type=style&index=0&id=47fefb72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fefb72",
  null
  
)

export default component.exports